export enum IExceptionTypeEnum {
  OFF = "Off",
  ON = "On",
}
